// The liquidity pool («Пул ліквідності», ExchangeLPVault, 2026-10-18) and the platform notifications.
// Data from exchange-svc; a provider's own transactions (withdrawal request, cancel) are built by tx-proxy,
// signed in the browser with the key that never leaves it, and sent like any other. Since 2026-10-25 the
// pool belongs to the platform (funded by m2 sales): users no longer deposit.
import api from './api';
import { sendBuilt } from './exchange.service';

const EX = 'exchange/v1';

export const getPool = async () => (await api.get(`${EX}/pool`)).data;
export const getPoolMe = async () => (await api.get(`${EX}/pool/me`)).data;
export const previewWithdraw = async (asset, shares) =>
  (await api.get(`${EX}/pool/preview`, { params: { asset, shares: shares.toString() } })).data;

export async function requestWithdrawal(shares, asset, credentials) {
  const r = await api.post('tx/v1/pool/request-withdrawal', { shares: shares.toString(), asset });
  return sendBuilt(r.data, credentials);
}

export async function cancelWithdrawal(id, credentials) {
  const r = await api.post('tx/v1/pool/cancel-withdrawal', { id: Number(id) });
  return sendBuilt(r.data, credentials);
}

// ------------------------------------------------------------- notifications (pop-ups until read)

export const getNotifications = async (unread) =>
  (await api.get(`${EX}/notifications`, { params: { unread: unread ? 1 : undefined, limit: 30 } })).data;
export const markRead = async (ids) => (await api.post(`${EX}/notifications/read`, { ids: ids || [] })).data;

// ------------------------------------------------------------- numbers

const E18 = 10n ** 18n;

// USD × 1e18 (or shares) as "1 234.56"
export function fromE18(v, decimals = 2) {
  let n;
  try {
    n = BigInt(v || 0);
  } catch (e) {
    return '—';
  }
  const neg = n < 0n;
  const a = neg ? -n : n;
  const scale = 10n ** BigInt(18 - decimals);
  const cut = a / scale;
  const s = cut.toString().padStart(decimals + 1, '0');
  const int = s.slice(0, s.length - decimals).replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
  const frac = decimals ? '.' + s.slice(s.length - decimals) : '';
  return (neg ? '-' : '') + int + frac;
}

// "123.45" USD -> USD × 1e18 (null when not a number with at most 2 decimals)
export function usdToE18(text) {
  const s = String(text || '').trim().replace(',', '.');
  if (!/^\d+(\.\d{0,2})?$/.test(s)) return null;
  const [int, frac = ''] = s.split('.');
  return BigInt(int) * E18 + BigInt((frac + '00').slice(0, 2)) * (E18 / 100n);
}

export { E18 };
